// extracted by mini-css-extract-plugin
module.exports = {"empty-container":"NoData_empty-container__9GYAF","emptyContainer":"NoData_empty-container__9GYAF"};